import { useEffect, useState } from "react";
import ProductService from "../service/ProductService";
import CategoryService from "../service/CategoryService";

const useCategories = ({ onCategoriesError, onSuccess } = {}) => {
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [categories, setCategories] = useState([]);

  const productService = new ProductService();
  const categoryService = new CategoryService();

  const fetchCategories = async () => {
    setLoadingCategories(true);
    try {
      let resCategories = await productService.getCategories();

      if (resCategories.messageCode !== 200001) {
        onCategoriesError(resCategories.messageCode);
      } else {
        if (onSuccess) {
          resCategories = onSuccess(resCategories.result);
        }
        setCategories(resCategories.result);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingCategories(false);
    }
  };

  const getCategoryById = async (categoryId) => {
    try {
      let resCategory = await categoryService.getCategoryById(categoryId);
      return resCategory.result;
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchCategories();

    return () => {
      setLoadingCategories(false);
      setCategories([]);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loadingCategories,
    categories,
    getCategoryById,
  };
};

export default useCategories;

